<template>
	<el-drawer :modal="false"  title="Redemption History" :visible.sync="is_visible" class="drawer-redemption-history" size="50%" @open="getListing()">
		<b-container>
			<div class="card-table-simple" v-loading="is_loading">
				<b-table-simple responsive class="mb-0">
					<b-thead>
						<b-tr>
							<b-th>Redemption<br>Date</b-th>
							<b-th>Efective<br>Date</b-th>
							<b-th>Interest<br>Amt. (RM)</b-th>
							<b-th>Settlement<br>Amt. (RM)</b-th>
							<b-th>Status</b-th>
							<b-th>Update By<br/>Update Date</b-th>
						</b-tr>
					</b-thead>
					<b-tbody>
						<b-tr v-for="(data, index) in tableData" :key="index">
							<b-td>{{ _gHlp.formatMomentDate(data.redem_date, 'D MMM, YYYY') }}</b-td>
							<b-td>{{ _gHlp.formatMomentDate(data.balance_date, 'D MMM, YYYY') }}</b-td>
							<b-td>{{ data.formula_sum.next_interest | moneyFormatter }}</b-td>
							<b-td>{{ data.settlement_amt | moneyFormatter }}</b-td>
							<b-td>
								<p class="top-line " :class="_gConst.getColor(data.status)">{{ data.status }}</p>
							</b-td>
							<b-td>
								<p class="top-line">{{ data.updater_name }}</p>
								<p class="bottom-line">{{ _gHlp.formatMomentDate(data.updated_at, 'D MMM, YYYY') }}</p>
							</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>
			</div>
		</b-container>
	</el-drawer>
</template>
<script>
import { Button, Drawer, Select, Option, DatePicker } from 'element-ui'
import { mapState, mapActions } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore'
import { useAccessControlStore } from '@/stores/accessControlStore'
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'

export default {
	components: {
		[Button.name]: Button,
		[Drawer.name]: Drawer,
		[Select.name]: Select,
		[Option.name]: Option,
		[DatePicker.name]: DatePicker,
	},
	data() {
		return {
			is_loading: false,
			is_visible: false,
			tableData: []
		}
	},
	methods: {
		...mapActions(useLoanCaseStore, ['getRedemList']),
		...mapActions(useAccessControlStore,['getUser']),
		show() {
			this.is_visible = true;
		},
		async getListing(refresh=false) {
			this.is_loading = true;
			const dataList = await this.getRedemList('all',refresh)
			
			//INJECT CUSTOMER DETAIL
			let tableData = [];
			for (let i = 0; i < dataList.length; i++) {
				let el = dataList[i];
				el['updater_name'] = await this.getUser(el.updated_by, 'name', '-');
				tableData.push(el);
			}
			this.tableData = tableData
			this.is_loading = false;
		}
	},
}
</script>